type RouteParams = {
  adminId?: string;
  donorId?: string;
  giveId?: string;
  pageId?: string;
  recipientId?: string;
  token?: string;
  userRole?: string;
  view?: string;
  destinationDonorId?: string;
  sourceDonorMergeToken?: string;
};

export function replaceRouteParams(
  route: string,
  routeParams: RouteParams
): string {
  let routeWithReplacedParams = route;

  Object.entries(routeParams).forEach(([key, value]) => {
    if (typeof value !== 'string') {
      throw new Error(`${key} is not a string`);
    }

    routeWithReplacedParams = routeWithReplacedParams.replace(
      new RegExp(`:${key}`, 'ig'),
      value
    );
  });

  return routeWithReplacedParams;
}
